import { FeatureFlags } from 'utils/featureFlags';
import { useFeatureFlagStatus } from './useFeatureFlag';

export interface CrmVariablesV2RouteFlag {
  enabled: boolean;
  isLoading: boolean;
}

export function useCrmVariablesV2RouteFlag(): CrmVariablesV2RouteFlag {
  const { flags, isLoading } = useFeatureFlagStatus([FeatureFlags.crmVariablesV2Route]);
  return { enabled: flags[FeatureFlags.crmVariablesV2Route] === true, isLoading };
}
